import type { ReactElement } from "react";
import ctl from "@netlify/classnames-template-literals";

type DividerVariant = "primary" | "accent" | "dark" | "darkPurple";
type DividerMargin = "none" | "xs" | "sm" | "mo" | "md" | "lg" | "xl" | "2xl";

interface Props {
  variant?: DividerVariant;
  margin?: DividerMargin;
}

export default function Divider({
  variant = "primary",
  margin = "md",
}: Props): ReactElement {
  const className = getClasses(variant, margin);

  return <hr className={className} />;
}

function getClasses(variant: DividerVariant, margin: DividerMargin) {
  const baseStyles = ctl(`
    border-0
    border-t
    border-neutral-200
  `);

  const variantStyles = {
    primary: ctl(`border-neutral-200`),
    accent: ctl(`border-purple-100 border-opacity-30`),
    dark: ctl(`border-neutral-700`),
    darkPurple: ctl(`border-purple-950`),
  };

  const marginStyles = {
    none: ctl(`my-0`),
    xs: ctl(`my-1`),
    sm: ctl(`my-2`),
    mo: ctl(`my-3`),
    md: ctl(`my-4`),
    lg: ctl(`my-6`),
    xl: ctl(`my-8`),
    "2xl": ctl(`my-16`),
  };

  return `${baseStyles} ${variantStyles[variant]} ${marginStyles[margin]}`;
}
